import React from "react";
import { StyledCheckbox } from "./style"

const Checkbox = (props) =>{
    return (
        <StyledCheckbox {...props}/>
    )
}

export default Checkbox